// extracted by mini-css-extract-plugin
export default {"grocery_button_container":"viewGroceryListCard_grocery_button_container__6TOBN","second_grid":"viewGroceryListCard_second_grid__Fsl3b"};